import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames/bind';

import Loader from 'components/Loader';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import { StaticTextContext } from 'context/StaticTextContext';
import { CountryContext } from 'context/CountryContext';
import { SearchContext } from 'context/SearchContext';

import { getCarDetails } from 'utils/getCarAutosuggestions';
import { getYearFormat, getMotorCodes } from 'utils/formatDataHelper';

import ArrowDown from 'media/icons/arrow-down.icon.svg';
import styles from './CarDetails.module.scss';
const cx = classNames.bind(styles);

const CarDetails = () => {
  const [isDisplayContnet, setIsDisplayContent] = useState(false);
  const [data, setData] = useState(false);
  const { labels } = useContext(StaticTextContext);
  const { vehicleType, carId } = useContext(SearchContext);
  const { currentCountry } = useContext(CountryContext);

  const setCarDetailsData = (carId) => () => {
    setIsDisplayContent(!isDisplayContnet);

    if (!data) {
      getCarDetails(carId, currentCountry, vehicleType)
        .then(({ data: response }) => {
          const carData = response.data.array ? response.data.array[0] : null;
          setData(carData);
        })
        .catch((error) => {
          setData(null);
          setIsDisplayContent(false);
        });
    }
  };

  useEffect(() => {
    setData(null);
    setIsDisplayContent(false);
  }, [carId]);

  if (!carId) {
    return null;
  }

  return (
    <div className={cx('car-details')}>
      <button
        className={cx('button', {
          'is-opened': isDisplayContnet,
        })}
        type="button"
        onClick={setCarDetailsData(carId)}
      >
        {labels.vehicleDetailsMainTitle}
        <span className={cx('icon')}>
          <ArrowDown />
        </span>
      </button>

      {data && isDisplayContnet && (
        <div className={cx('content')}>
          <ul className={cx('listing')}>
            {data.vehicleDetails.manuName && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsTypeLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.manuName + ' '}
                  {data.vehicleDetails.modelName + ' '}
                  {data.vehicleDetails.typeName}
                </span>
              </li>
            )}
            {data.vehicleDetails.yearOfConstrFrom ||
            data.vehicleDetails.yearOfConstrTo ? (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsYearLabel}
                </span>
                <span className={cx('column')}>
                  {getYearFormat(data.vehicleDetails.yearOfConstrFrom)}
                  {' - ' + getYearFormat(data.vehicleDetails.yearOfConstrTo)}
                </span>
              </li>
            ) : null}
            {data.vehicleDetails.powerKwFrom &&
            data.vehicleDetails.powerHpFrom ? (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsPerformanceLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.powerKwFrom + ' kW'}
                  &nbsp;/&nbsp;
                  {data.vehicleDetails.powerHpFrom + ' HP'}
                </span>
              </li>
            ) : null}
            {data.vehicleDetails.cylinderCapacityCcm &&
            data.vehicleDetails.cylinderCapacityLiter ? (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsCapacityLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.cylinderCapacityCcm + ' cc'}
                  &nbsp;/&nbsp;
                  {data.vehicleDetails.cylinderCapacityLiter + ' l'}
                </span>
              </li>
            ) : null}
            {data.vehicleDetails.cylinder && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsCylinderLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.cylinder}
                </span>
              </li>
            )}
            {data.vehicleDetails.valves && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsValvesLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.valves}
                </span>
              </li>
            )}
            {data.vehicleDetails.constructionType && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsConstructionLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.constructionType}
                </span>
              </li>
            )}
            {data.vehicleDetails.brakeSystem && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsBrakeLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.brakeSystem}
                </span>
              </li>
            )}
            {data.vehicleDetails.impulsionType && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsDriveTypeLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.impulsionType}
                </span>
              </li>
            )}
            {data.vehicleDetails.motorType && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsEngineTypeLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.motorType}
                </span>
              </li>
            )}
            {data.vehicleDetails.fuelType && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsFuelTypeLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.fuelType}
                </span>
              </li>
            )}
            {data.vehicleDetails.fuelTypeProcess && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsFuelMixtureLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.fuelTypeProcess}
                </span>
              </li>
            )}
            {data.vehicleDetails.typeNumber && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsTecDocTypeLabel}
                </span>
                <span className={cx('column')}>
                  {data.vehicleDetails.typeNumber}
                </span>
              </li>
            )}
            {data.motorCodes && (
              <li className={cx('item')}>
                <span className={cx('column', 'label')}>
                  {labels.vehicleDetailsEngineCodesLabel}
                </span>
                <span className={cx('column')}>
                  {getMotorCodes(data.motorCodes.array)}
                </span>
              </li>
            )}
          </ul>
        </div>
      )}
      {!data && isDisplayContnet && <Loader className={cx('loader')} />}
    </div>
  );
};

export default withErrorBoundary(CarDetails);



// WEBPACK FOOTER //
// ./src/components/CarDetails/CarDetails.js